import React from 'react';

export default () => <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg%22"><circle cx="7" cy="7" r="5" fill="white" stroke="#80C07B" strokeWidth="4" /></svg>;
